// general helpers
import {apiRoot} from './api';

//this for keyboard typing waiting time on search
export const typingWaitingTime = 500;

export const getImage = (path) => {
  var filePath;
  if (path && path.startsWith('http')) {
    filePath = path;
  } else {
    filePath = apiRoot + '/api/image/' + path;
  }

  return filePath;
};
